import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import styled from "styled-components";
import Loader from "./components/utils/Loader";
import mainStore from "./store/index";

function PrivateRouteAdmin({ children }) {
  const STORE = mainStore();

  const [userlogged, setuserlogged] = useState(null);
  const [usersuperadmin, setUserSuperAdmin] = useState(null);

  const [isloader, setLoader] = useState(true);

  useEffect(() => {
    setLoader(true);
    let logged = STORE.handleUserlogged();

    let admin = STORE.user;

    setuserlogged(logged);

    setLoader(false);
  }, []);

  return isloader ? (
    <LoaderPage>
      <Loader color="#3498db" />
    </LoaderPage>
  ) : userlogged ? (
    children
  ) : (
    <Navigate to="/login" />
  );
}

const LoaderPage = styled.div`
  width: 100%;
  height: 100vh;
  background: white;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
export default PrivateRouteAdmin;
